import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { HttpResponse, JobUpdate } from "@/types";

export const jobUpdatesQueryKey = ({
  companyId,
  jobId,
  uniqueDescriptions,
}: {
  companyId: string;
  jobId: string;
  uniqueDescriptions?: boolean;
}) => ["job-updates", companyId, jobId, { uniqueDescriptions }] as const;

export function useGetJobUpdates({
  companyId,
  enabled = true,
  jobId,
  uniqueDescriptions,
}: {
  companyId: string;
  enabled?: boolean;
  jobId: string;
  uniqueDescriptions?: boolean;
}) {
  return useQuery({
    queryKey: jobUpdatesQueryKey({ companyId, jobId, uniqueDescriptions }),
    queryFn: async () => {
      const queryParams = new URLSearchParams();
      if (uniqueDescriptions) {
        queryParams.set("uniqueDescriptions", "true");
      }

      const queryString = queryParams.toString();
      const path = `companies/${companyId}/jobs/${jobId}/job-updates${queryString ? `?${queryString}` : ""}`;
      const res = await guacHttpClient.get<
        JobUpdate[],
        HttpResponse<JobUpdate[]>
      >(path);
      return res.data;
    },
    enabled,
  });
}
